import L from "leaflet";

export const getDistanceOnLine = (linePositions, clickLatLng) => {
  let total = 0;

  let best = {
    dist: Infinity,
    point: null,
    offset: 0
  };

  for (let i = 0; i < linePositions.length - 1; i++) {
    const p1 = L.latLng(linePositions[i]);
    const p2 = L.latLng(linePositions[i + 1]);
    const p = L.latLng(clickLatLng);

    const dx = p2.lng - p1.lng;
    const dy = p2.lat - p1.lat;

    const t =
      ((p.lng - p1.lng) * dx + (p.lat - p1.lat) * dy) /
      (dx * dx + dy * dy);

    let proj;

    if (t < 0) proj = p1;
    else if (t > 1) proj = p2;
    else {
      proj = L.latLng(
        p1.lat + dy * t,
        p1.lng + dx * t
      );
    }

    const dist = p.distanceTo(proj);

    if (dist < best.dist) {
      best.dist = dist;
      best.point = proj;
      best.offset = total + p1.distanceTo(proj);
    }

    total += p1.distanceTo(p2);
  }

  return {
    point: best.point,
    a: best.offset,
    b: total - best.offset,
    total
  };
};